/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
const isMobile = window.innerWidth < 768;
const cardShadowHover = `0 10px 20px rgba(0,0,0,0.25), 0 7px 7px rgba(0,0,0,0.22)`;

export const CardContainerVariant: any = {
  whileHover: !isMobile
    ? {
        scale: 1.05,
        borderRadius: '10px',
        boxShadow: cardShadowHover,
        padding: '10px',
      }
    : {},
  transition: !isMobile
    ? {
        duration: 0.1,
      }
    : {},
};
